"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var useChildRef = function useChildRef(children) {
  var ref = (0, _react.useRef)(null); // Verifies that children has only one child (a React element) and returns it.

  var childElement = _react["default"].Children.only(children); // Pass ref


  return /*#__PURE__*/(0, _react.cloneElement)(childElement, {
    ref: ref
  });
};

var _default = useChildRef;
exports["default"] = _default;
//# sourceMappingURL=useChildRef.js.map